<template>
  <div>
    <div>
      <div class="row">
        <div class="col-10">
          <div class ="row" v-if="isFilter" style="height:70px">
            <div class="col-2" v-if="isEntityFilter">
              <h6> Entity</h6>
              <select class="form-control" v-model="selectedentity">
                  <option disabled value="">Entity</option>
                  <option v-for="entity in entities" v-bind:key="entity.id" v-bind:value="entity.name">{{ entity.name }}</option>
              </select>
            </div>
            <div class="col-2" v-if="isBranchFilter">
              <h6>Branch</h6>
              <select class="form-control" v-model="selectedbranch">
                  <option disabled value="">Branch</option>
                  <option v-for="branch in branches" v-bind:key="branch.id" v-bind:value="branch.name">{{ branch.name }}</option>
              </select>
            </div>
            <div class="col-2" v-if="isDeliveredFyFilter">
              <h6>Delivered FY</h6>
              <select class="form-control" v-model="selectedfy">
                  <option disabled value="">Delivered FY</option>
                  <option v-for="fy in years" v-bind:key="fy.id" v-bind:value="fy.name">{{ fy.name }}</option>
              </select>
            </div>
            <div class="col-2" v-if="isDeliveredFilter">
              <h6>Delivered Year</h6>
              <select class="form-control" v-model="selectedyear">
                  <option disabled value="">Delivered Year</option>
                  <option v-for="year in years" v-bind:key="year.id" v-bind:value="year.name">{{ year.name }}</option>
              </select>
            </div>
            <div class="col-2" v-if="isCurrencyFilter">
              <h6>Currency</h6>
              <select class="form-control" v-model="selectedcurrency">
                  <option disabled value="">Currency</option>
                  <option v-for="currency in currencies" v-bind:key="currency.id" v-bind:value="currency.name">{{ currency.name }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-2 float-right" style="height:30px" >
          <a :href="redashurl" target="_blank">
            Open with Redash
          </a>
        </div>
      </div>
    </div>
    <!--Charts-->
    <div class="row">
      <div class="col-12">
        <div class="embed-responsive iframe embed-responsive-16by9">
           <iframe class="embed-responsive-item" 
                    :src=redashurl
                    width="100%" 
                    height="auto" 
                    frameborder="0" 
                    lazyload="on" ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
 data() {
   return {
    selectedentity: 'PrecenaIDN',
    selectedfy: '2019',
    selectedyear: '2019',
    selectedcurrency: 'sgd',
    selectedbranch: 'マゼラン支店',
    iframeURL: "",
    entities: [
        { id:1, name: 'PrecenaIDN'},
        { id:2, name: 'PrecenaJP' },
        { id:3, name: 'PrecenaKR' },
        { id:4, name: 'PrecenaSG' },
        { id:5, name: 'PrecenaMY' },
    ],
    currencies: [
        { id:2, name: 'jpy' },
        { id:1, name: 'sgd'},
        { id:3, name: 'krw' },
        { id:4, name: 'idr' },
        { id:5, name: 'myr' },
    ],
    years: [
        { id:1, name: '2015'},
        { id:2, name: '2016'},
        { id:3, name: '2017'},
        { id:4, name: '2018'},
        { id:5, name: '2019'},
        { id:6, name: '2020'},
        { id:7, name: '2021'},
        { id:8, name: '2022'},
        { id:9, name: '2023'},
        { id:10, name: '2024'},
        { id:11, name: '2025'},
        { id:12, name: '2026'},
    ],
    branches: [
        { id:2, name: 'Blitz Branch'},
        { id:1, name: 'SORA Branch'},
        { id:3, name: 'SAKURA branch'},
        { id:4, name: 'iii branch'},
        { id:5, name: 'Argonauts branch'},
        { id:8, name: 'Argonauts Branch'},
        { id:6, name: 'BSA branch'},
        { id:7, name: 'Magellan branch'},
        { id:9, name: 'HANABI Branch'},
        { id:10, name: 'Takenoko Branch'},
    ],
   }
 },
 props: { 
   dashboardurl: String,
   isFilter: Boolean,
   isEntityFilter: Boolean,
   isDeliveredFyFilter: Boolean,
   isDeliveredFilter: Boolean,
   isCurrencyFilter: Boolean,
   isBranchFilter: Boolean
 },
 beforeMount() {
   if(localStorage.selectedentity){
      this.selectedentity = localStorage.selectedentity
   }
   if(localStorage.selectedfy){
      this.selectedfy = localStorage.selectedfy
   }
   if(localStorage.selectedyear){
      this.selectedyear = localStorage.selectedyear
   }
   if(localStorage.selectedcurrency){
      this.selectedcurrency = localStorage.selectedcurrency
   }
   if(localStorage.selectedbranch){
      this.selectedbranch = localStorage.selectedbranch
   }
 },
 computed:{
   redashurl() {
     this.iframeURL = "https://redash.precena.com" + this.dashboardurl
     if (this.isFilter) {
       if (this.isEntityFilter){
         this.iframeURL = this.iframeURL + "&p_entity=" + this.selectedentity
         localStorage.selectedentity = this.selectedentity
       }
       if (this.isDeliveredFyFilter){
         this.iframeURL = this.iframeURL + "&p_delivered_year_fy=" + this.selectedfy
         localStorage.selectedfy = this.selectedfy
       }
       if (this.isDeliveredFilter){
         this.iframeURL = this.iframeURL + "&p_delivered_year=" + this.selectedyear
         localStorage.selectedyear = this.selectedyear
       }
       if (this.isCurrencyFilter){
         this.iframeURL = this.iframeURL + "&p_currency=" + this.selectedcurrency
         localStorage.selectedcurrency = this.selectedcurrency
       }
       if (this.isBranchFilter){
         this.iframeURL = this.iframeURL + "&p_branch_name=" + this.selectedbranch
         localStorage.selectedbranch = this.selectedbranch
       }
     }
     return this.iframeURL
   },
 },
}
</script>